export const invoiceRepositoryFiltersSchema = {
  properties: {
    nip: { title: 'NIP wystawcy', type: 'string' },
    number: { title: 'Numer faktury/rachunku', type: 'string' },
    date: { title: 'Data wystawienia', type: 'string', format: 'date' }
  },
  title: 'Filtry repozytorium faktur',
  type: 'object'
};
